<template>
  <v-select
    :value="value"
    :items="items"
    :label="label"
    :disabled="disabled"
    :placeholder="placeholder"
    :clearable="clearable"
    outlined
    dense
    hide-details
    @change="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: "EnumSelect",
  props: {
    value: {
      type: Number,
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: "",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
  },
};
</script>